window.theme.component('category-picker', el => {
	const trigger = el.querySelector('.js-category-picker-trigger');
	const overlay = el.querySelector('.js-category-picker-overlay');
	const backdrop = el.querySelector('.js-category-picker-backdrop');
	const closeButton = el.querySelector('.js-category-picker-close');
	const searchInput = el.querySelector('.js-category-picker-search');
	const label = el.querySelector('.js-category-picker-label');
	const valueInput = el.querySelector('.js-category-picker-value');
	const options = el.querySelectorAll('.js-category-picker-option');
	const groups = el.querySelectorAll('.js-category-picker-group');

	if (!trigger || !overlay || !valueInput) return;

	// Accent-insensitive match, same technique as category-select.
	function normalize(text) {
		return text.trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
	}

	function filterOptions(query) {
		const term = normalize(query);

		options.forEach(option => {
			const matches = !term || normalize(option.textContent).indexOf(term) !== -1;
			option.classList.toggle('is-hidden', !matches);
		});

		groups.forEach(group => {
			const visibleOptions = group.querySelectorAll('.js-category-picker-option:not(.is-hidden)');
			group.classList.toggle('is-hidden', visibleOptions.length === 0);
		});
	}

	function openPanel() {
		overlay.hidden = false;
		overlay.classList.add('is-open');
		trigger.setAttribute('aria-expanded', 'true');
		document.body.classList.add('scroll-lock');

		if (searchInput) {
			searchInput.value = '';
			filterOptions('');
			setTimeout(() => searchInput.focus(), 50);
		}
	}

	function closePanel() {
		overlay.classList.remove('is-open');
		overlay.hidden = true;
		trigger.setAttribute('aria-expanded', 'false');
		document.body.classList.remove('scroll-lock');
	}

	function selectOption(option) {
		const value = option.dataset.value || '';
		valueInput.value = value;
		valueInput.dispatchEvent(new Event('change', { bubbles: true }));
		if (label) label.textContent = value || option.textContent.trim();
		options.forEach(o => o.classList.toggle('is-active', o === option));
		closePanel();
	}

	trigger.addEventListener('click', () => {
		if (overlay.classList.contains('is-open')) {
			closePanel();
		} else {
			openPanel();
		}
	});

	if (closeButton) closeButton.addEventListener('click', closePanel);
	if (backdrop) backdrop.addEventListener('click', closePanel);

	document.addEventListener('keydown', event => {
		if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
			closePanel();
		}
	});

	if (searchInput) {
		searchInput.addEventListener('input', () => filterOptions(searchInput.value));
	}

	options.forEach(option => {
		option.addEventListener('click', () => selectOption(option));
	});
});
